<template>
    <form :action="action" class="registration-form" method="POST" v-if="form">
        <input type="hidden" name="_token" :value="csrkToken" />

        <md-card :class="{'profil-form': true, 'profil-form-mobile': true, 'profil-form-mobile-content': !showForm}">
            <md-card-header>
                <h2 class="md-title md-title-dark" v-html="showForm ? title : contentTitle" />
            </md-card-header>

            <md-card-content class="mb-30">
                <div v-if="!showForm" v-html="contentLeft" />
                <template v-else>
                    <div class="form-row" :class="{'has-error': errors.email}" v-if="showEmailField">
                        <md-field :class="{'md-invalid': !!errors.email}">
                            <label>{{ $t('registration.your-email') }}</label>
                            <md-input
                                type="email"
                                name="email"
                                v-model="fData.email"
                                :disabled="submitting ? 'disabled' : null"
                                dusk="email-input"
                                required
                            />
                            <span class="md-error" v-html="errors.email ? errors.email[0] : ''" />
                        </md-field>
                    </div>
                    <div class="form-row" :class="{'has-error': errors.password}">
                        <md-field :class="{'md-invalid': !!errors.password}">
                            <label>{{ $t('registration.password') }}</label>
                            <md-input
                                type="password"
                                name="password"
                                v-model="fData.password"
                                :disabled="submitting ? 'disabled' : null"
                                @focus="passwordFieldFocused = true; passwordFieldTouched = true"
                                @blur="passwordFieldFocused = false;"
                                required
                            />
                            <span class="md-error">{{ errors.password ? errors.password[0] : '' }}</span>
                        </md-field>
                    </div>
                    <div class="form-row" :class="{'has-error': errors.password_confirmation}">
                        <md-field :class="{'md-invalid': !!errors.password_confirmation}">
                            <label>{{ $t('registration.password-confirmation') }}</label>
                            <md-input
                                type="password"
                                name="password_confirmation"
                                v-model="fData.password_confirmation"
                                :disabled="submitting ? 'disabled' : null"
                                required
                            />
                            <span
                                class="md-error"
                            >{{ errors.password_confirmation ? errors.password_confirmation[0] : '' }}</span>
                        </md-field>
                    </div>

                    <div
                        class="text-grey-light"
                        :class="{'v-hidden' : errors.password && errors.password.length || errors.password_confirmation && errors.password_confirmation.length }"
                    >
                        <i>{{ $t('validation.passwordrules') }}</i>
                    </div>

                    <div class="form-row form-row-submit">
                        <div class="form-submit-button">
                            <p class="text-center" v-html="$t('registration.accept-tos')" />
                            <submit-button
                                type="submit"
                                class="registration-standalone-button"
                                :submitting="submitting"
                                :label="$t('registration.continue')"
                                @click="onSubmit()"
                                dusk="submit-profile-button"
                            />
                        </div>
                    </div>
                </template>
            </md-card-content>

            <md-card-actions v-if="!showForm">
                <submit-button
                    type="submit"
                    class="registration-standalone-button i-register-mobile-button"
                    :label="registerButtonLabel"
                    @click="showForm = true"
                />
            </md-card-actions>
        </md-card>
    </form>
</template>

<script>
export default {
    props: {
        action: {
            type: String,
            required: true,
        },
        formString: {
            type: String,
            required: true,
        },
        fromAirportId: {
            type: String,
            default: "",
        },
        toAirportId: {
            type: String,
            default: "",
        },
        countryId: {
            type: String,
        },
        templateString: {
            type: String,
        },
        introPhrase: {
            type: String,
            default: "fill-profile-freemium",
        },
        // displayLegalStatusField: {
        //     type   : Boolean,
        //     default: true,
        // },
        showEmailField: {
            type: Boolean,
            default: false,
        },
        entityTypesString: {
            type: String,
            required: true,
        },
        registrationPageId: String,
        contentLeft: String,
        contentTitle: String,
    },
    data() {
        return {
            fData: {
                email: '',
                password: '',
                password_confirmation: '',
                accept_email: true,
            },
            errors: {
                email: null,
                password: null,
                password_confirmation: null,
            },
            csrkToken: Laravel.csrfToken,
            submitting: false,
        };
    },
    computed: {
        form() {
            return this.parseProp(this.formString);
        },
        template() {
            return this.parseProp(this.templateString) || {};
        },
        title() {
            if (
                !this.template.form_title ||
                !this.template.form_title[this.$i18n.locale()]
            ) {
                return this.$t("registration." + this.introPhrase);
            }

            return this.template.form_title[this.$i18n.locale()];
        },
        entityTypes() {
            return this.parseProp(this.entityTypesString);
        },
        showForm: {
            get() {
                return this.template.template_name === 'default' || this.$route.query.show_form === '1';
            },
            set(value) {
                this.$router.push({query: {...this.$route.query, show_form: value ? '1' : '0'}});
            },
        },
        registerButtonLabel() {
            if (this.template.register_button_label && this.template.register_button_label[this.$i18n.locale()]) {
                return this.template.register_button_label[this.$i18n.locale()];
            } else {
                return this.$t('home.i-register');
            }
        },
    },
    mounted() {
        this.setupForm();
    },
    methods: {
        parseProp(prop) {
            if (!prop) {
                return;
            }

            return JSON.parse(prop);
        },
        setupForm() {
            if (!this.form) {
                return;
            }

            for (let i of Object.keys(this.form)) {
                this.fData[i] = this.form[i];
            }

            this.fData.password_confirmation = this.fData.password;

            if (this.fromAirportId) {
                this.fData.airport_id = this.fromAirportId;
            }
            if (this.toAirportId) {
                this.fData.destination_airport_id = this.toAirportId;
            }
        },
        onSubmit() {
            this.submitting = true;

            for (let i of Object.keys(this.errors)) {
                this.errors[i] = null;
            }

            axios
                .post(this.action, {
                    ...this.fData,
                    registration_page_id: this.registrationPageId,
                })
                .then(({ data }) => {
                    if (data.status === "ok") {
                        window.location = data.redirect;
                    }

                    this.submitting = false;
                })
                .catch(
                    ({
                        response: {
                            data: { errors },
                        },
                    }) => {
                        this.submitting = false;

                        for (let i of Object.keys(this.errors)) {
                            this.errors[i] = errors[i];
                        }
                    }
                );
        },
    },
};
</script>
<style lang="scss">
.registration-form {
    .md-title em {
        font-weight: 400;
        font-size: 0.95em;
    }
}
.profil-form-mobile {
    .text-grey-light {
        color: rgba(0, 0, 0, 0.54);
        i {
            font-size: 10px;
        }
    }
    padding: 20px;
    .md-card-header {
        .md-title {
            font-size: 20px !important;
        }
    }
    .md-card-content {
        .md-field {
            label {
                font-size: 12px;
            }
        }
        .md-checkbox-label {
            font-size: 10px !important;
        }
    }
    .form-row.has-error {
        min-height: 100px;
    }
}
.profil-form-mobile-content {
    display: flex;
    flex-direction: column;
    height: 100vh !important;
    max-height: 100vh !important;
    padding: 0;
    .md-card-content {
        //overflow-y: auto;
        padding: 0;
        padding-bottom: 46px;
    }
    .md-card-actions {
        padding: 0;
        position: fixed;
        bottom: 0;
        width: 100%;
        .md-button {
            margin: 5px 0 0 0 !important;
            width: 100% !important;
            border-radius: 0 !important;
            height: 60px;
        }
    }
    .registration-content {
        > *:not(:first-child) {
            margin-left: 20px !important;
            margin-right: 20px !important;
        }
    }
    video {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/registration/Profile/formMobile.vue